import { ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { HOMI_STORAGE } from '@lyceo/homi/shared/util';
import { SettingsState } from './settings.reducer';

export function settingsLocalStorageSyncReducer(
  reducer: ActionReducer<SettingsState>,
): ActionReducer<SettingsState> {
  return localStorageSync({
    keys: ['language'],
    rehydrate: true,
    removeOnUndefined: true,
    storageKeySerializer: (key) => `${HOMI_STORAGE}/settings/${key}`,
  })(reducer);
}
